module.exports = __webpack_public_path__ + "logo_PayrollVault.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_PayrollVault.png
// module id = 860
// module chunks = 0